import { cloneDeep } from 'lodash-es';
import { useState, useCallback, useEffect, useRef } from 'react';

export const useToggleState = (
  selectedPublishers = [],
  foundedPublishers = [],
  setSearch,
  setSelectedPublishers,
  search,
  setIsOpen,
  isOpen,
) => {
  const [state, stateSet] = useState(selectedPublishers);
  const formIsChanged = useRef(false);

  useEffect(() => {
    stateSet(selectedPublishers);
  }, [selectedPublishers, isOpen]);

  const isActive = useCallback(
    (pb_number) => {
      return state.find((publisher) => publisher.pb_number === pb_number) ? true : false;
    },
    [state],
  );

  const isGlobal = useCallback(
    (pb_number) => {
      const currentPublisher = state.find((publisher) => publisher.pb_number === pb_number);
      return currentPublisher?.isGlobal;
    },
    [state],
  );

  const deleteItem = (pb_number) => {
    let newItems = cloneDeep(state);
    newItems = newItems.filter((publisher) => publisher.pb_number !== pb_number);
    stateSet(newItems);
    formIsChanged.current = true;
  };

  const findItem = (pb_number, foundedPublishers) => {
    return foundedPublishers.concat(state).find((publisher) => publisher.pb_number === pb_number);
  };

  const addItem = (obj) => {
    let newItems = cloneDeep(state);
    newItems = newItems.concat({ ...obj, selected: true });
    stateSet(newItems);
    formIsChanged.current = true;
  };

  const toggle = useCallback(
    (checked, pb_number) => {
      return isActive(pb_number)
        ? deleteItem(pb_number)
        : addItem(findItem(pb_number, foundedPublishers));
    },
    [isActive, foundedPublishers],
  );

  const handleSaveSelectedPublishers = useCallback(() => {
    setSelectedPublishers(state);
    setIsOpen(false);
    setSearch('');
  }, [state]);

  const handleSearchOnChange = useCallback((e) => {
    setSearch(e.target.value || '');
  }, []);

  const handleClearSearchValue = useCallback(() => {
    setSearch('');
  }, []);

  const itemsToShow = search ? foundedPublishers : state;

  return {
    isGlobal,
    isActive,
    toggle,
    handleSaveSelectedPublishers,
    handleSearchOnChange,
    handleClearSearchValue,
    itemsToShow,
    formIsChanged,
  };
};
